// extracted by css-extract-rspack-plugin
export default {"container":"container--B24UJb_IzgEfelIh"};